import { useCallback, useEffect, useState } from "react";
import { Lightbulb, Map, Trash2, Ban, Undo2, ChevronUp } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { confirmDialog } from "../ConfirmHost";

export const IdeasAdmin = () => {
  const [items, setItems] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/ideas").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const act = async (fn, okMsg) => {
    try {
      await fn();
      toast.success(okMsg);
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div data-testid="admin-ideas-section" className="mb-10">
      <h2 className="font-heading font-bold text-lg flex items-center gap-2 mb-4"><Lightbulb className="w-5 h-5 text-amber-500" /> Ideeënbord ({items.length})</h2>
      <div className="space-y-2" data-testid="admin-ideas-list">
        {items.length === 0 && <p className="text-sm text-muted-foreground bg-card rounded-2xl p-5 text-center">Nog geen ideeën van bezoekers.</p>}
        {items.map((i) => (
          <div key={i.id} data-testid={`admin-idea-row-${i.id}`} className={`bg-card rounded-2xl px-4 py-3 flex items-center gap-3 ${i.status === "afgewezen" ? "opacity-50" : ""}`}>
            <span className="flex items-center gap-1 font-mono font-bold text-sm text-primary shrink-0" title="Stemmen">
              <ChevronUp className="w-4 h-4" strokeWidth={3} />{i.votes}
            </span>
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-sm truncate">{i.title}</p>
              <p className="text-xs text-muted-foreground truncate">{i.author_name} · {i.created_at ? new Date(i.created_at).toLocaleDateString("nl-BE") : ""}{i.status === "gepland" && " · op de roadmap"}{i.status === "afgewezen" && " · afgewezen"}</p>
            </div>
            <div className="flex gap-1 shrink-0">
              {i.status === "open" && (
                <>
                  <button data-testid={`admin-idea-promote-${i.id}`} title="Zet op roadmap"
                    onClick={() => act(() => api.post(`/admin/ideas/${i.id}/promote`), "Idee staat op de roadmap (stemmen gaan mee)")}
                    className="p-2 rounded-full hover:bg-secondary text-primary transition-[background-color] duration-200">
                    <Map className="w-4 h-4" />
                  </button>
                  <button data-testid={`admin-idea-reject-${i.id}`} title="Afwijzen"
                    onClick={() => act(() => api.patch(`/admin/ideas/${i.id}`, { status: "afgewezen" }), "Idee afgewezen (niet meer zichtbaar op het bord)")}
                    className="p-2 rounded-full hover:bg-secondary text-muted-foreground transition-[background-color] duration-200">
                    <Ban className="w-4 h-4" />
                  </button>
                </>
              )}
              {i.status === "afgewezen" && (
                <button data-testid={`admin-idea-restore-${i.id}`} title="Terugzetten"
                  onClick={() => act(() => api.patch(`/admin/ideas/${i.id}`, { status: "open" }), "Idee staat weer op het bord")}
                  className="p-2 rounded-full hover:bg-secondary text-primary transition-[background-color] duration-200">
                  <Undo2 className="w-4 h-4" />
                </button>
              )}
              <button data-testid={`admin-idea-delete-${i.id}`} title="Verwijderen"
                onClick={async () => (await confirmDialog(`Idee "${i.title}" definitief verwijderen?`, { title: "Idee verwijderen", confirmLabel: "Verwijderen", destructive: true })) && act(() => api.delete(`/admin/ideas/${i.id}`), "Idee verwijderd")}
                className="p-2 rounded-full hover:bg-red-50 text-red-500 transition-[background-color] duration-200">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
